import React from 'react';

const MaintenanceScreen = () => {
    return (
        <div className="min-h-screen bg-white d-flex align-items-center justify-content-center p-4">
            <div className="text-center max-w-md">
                {/* Logo */}
                <div className="mb-6">
                    <img 
                        src="/android-chrome-192x192.png" 
                        alt="Cirenio" 
                        className="mx-auto"
                        style={{ width: '100px', height: '100px' }}
                    />
                </div>

                {/* Icono de mantenimiento */}
                <div className="mb-4">
                    <i className="bi bi-tools" style={{ fontSize: '4rem', color: '#6c757d' }}></i>
                </div>

                {/* Mensaje Principal */}
                <h1 className="text-3xl font-semibold mb-4" style={{ color: '#212529' }}>
                    Sistema en Mantenimiento
                </h1>

                {/* Descripción */}
                <p className="text-gray-600 mb-6" style={{ fontSize: '1.1rem' }}>
                    Estamos realizando mejoras en el sistema para brindarte un mejor servicio.
                </p>

                <p className="text-gray-600 mb-6">
                    Por favor, intentá nuevamente en unos momentos.
                </p>

                {/* Card con información adicional */}
                <div className="bg-gray-50 p-4 rounded-lg mb-4">
                    <p className="text-gray-600 mb-0">
                        <i className="bi bi-info-circle me-2"></i>
                        Si tenés una consulta urgente, contactá a tu financiera.
                    </p>
                </div>

                {/* Footer */}
                <p className="text-sm text-gray-500 mt-4">
                    Gracias por tu paciencia
                </p>
            </div>
        </div>
    );
};

export default MaintenanceScreen;

